module.exports = require("scope-css");